import moment from 'moment'

export const findProductsHandlerdById = (id, productds) => {
    if (id) {
        const results = []
        const prods = productds
        for (const key in prods) {
            const product = prods[key]
            const findItem = product.find((data) => data.id_produto.toString() === id.toString())
            console.log('item Found: ', findItem)
            if (findItem) {
                results.push(findItem)
            }
        }
        return results
    }
    return
}


export const findProdByIdHasBefore = (kitsArray, product_id) => {
    // Build an array of kits containing the target product
    const result = kitsArray.kits.map(kit => {
        // Find the product within the current kit's products
        const foundProduct = kit.kit_products.find(prod => prod.product_id === product_id);

        // If the product is found, include it in the result array; otherwise, skip
        console.log('prods here', foundProduct)
        return foundProduct
            ? {
                kit_number: kit.kit_number,
                created_at: kit.created_at,
                returned_at: kit.returned_at,
                is_active: kit.is_active,
                is_paid: kit.is_paid,
                pay_date: kit.pay_date,
                kit_products: foundProduct,
                prod_situation: foundProduct.sold_out,
                tamanho: foundProduct?.tamanho || null,
                imageUrl: foundProduct?.imageUrl || null,
            }
            : null;
    }).filter(item => item !== null); // Filter out any null entries where the product was not found

    return result;
};



export const formatProdsSheet = (data) => {
    const headers = data[0]
    const newArr = []

    data.slice(1).forEach((prodsArrAll, i) => {
        const newObj = {}
        prodsArrAll.forEach((element, index) => {
            // console.log('element', element, 'index', headers[index])
            if (headers[index] === 'Data') {
                newObj[headers[index]] = moment(new Date(element)).format("YYYY-MM-DD");
            }
            else {
                newObj[headers[index]] = element
            }
        });
        newArr.push(newObj)
    })
    return newArr
}